export default __webpack_public_path__ + "static/media/greeting18.6d86a887.png";